document.addEventListener('DOMContentLoaded', function() {
  // Rend visible sans animation. Sert de filet de securite quand GSAP manque,
  // et de repli au crochet public.
  function showAll(root) {
    (root || document).querySelectorAll('[data-reveal]').forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
  }

  // Filet de securite : le contenu en [data-reveal] est masque par CSS
  // (proart-animations.css) et n'est rendu visible que par GSAP, charge depuis
  // cdnjs. Sortir en silence laissait ce contenu invisible pour toujours — et
  // product-card.liquid porte data-reveal="fade-up", donc c'est tout le
  // catalogue qui disparaissait si le CDN tiers etait bloque ou indisponible.
  // Pas de flash au chargement normal : les <script defer> s'executent dans
  // l'ordre du document, GSAP passe toujours avant ce fichier. Ce garde ne se
  // declenche donc que sur un vrai echec de chargement, jamais sur une lenteur.
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    showAll(document);
    // Le contenu injecte apres coup doit rester visible lui aussi.
    window.proartReveal = showAll;
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  if (typeof CustomEase !== 'undefined') {
    gsap.registerPlugin(CustomEase);
    CustomEase.create('proart', '0.25, 0.46, 0.45, 0.94');
  }

  var ease = typeof CustomEase !== 'undefined' ? 'proart' : 'power2.out';

  // Hero parallax (only if hero section exists)
  if (document.querySelector('.hero__bg-img')) {
    gsap.to('.hero__bg-img', {
      yPercent: 20,
      ease: 'none',
      scrollTrigger: {
        trigger: '.hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true
      }
    });
  }

  // fade-up reveals
  function fadeUp(el) {
    gsap.fromTo(el,
      { opacity: 0, y: 60 },
      {
        opacity: 1, y: 0, duration: 0.9,
        ease: ease,
        scrollTrigger: { trigger: el, start: 'top 85%', once: true }
      }
    );
  }

  // line-draw reveals (scaleX animation)
  function lineDraw(el) {
    gsap.fromTo(el,
      { scaleX: 0 },
      {
        scaleX: 1, duration: 1.2, ease: 'power2.inOut',
        scrollTrigger: { trigger: el, start: 'top 85%', once: true }
      }
    );
  }

  // stagger-children — children fade up with stagger
  function staggerChildren(el) {
    gsap.fromTo(Array.from(el.children),
      { opacity: 0, y: 40 },
      {
        opacity: 1, y: 0, duration: 0.8,
        ease: ease,
        stagger: 0.1,
        scrollTrigger: { trigger: el, start: 'top 85%', once: true }
      }
    );
  }

  // counter animations
  function counter(el) {
    // Le champ « Chiffre » est du texte libre : « 24 », « 1000+ », « 100 % ».
    // parseInt seul renvoyait 1000 pour « 1000+ » et l'animation écrasait le
    // suffixe. On isole le nombre et on réapplique ce qui l'entoure.
    var parts = String(el.dataset.target || '').match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!parts) return;

    var prefix = parts[1];
    var target = parseFloat(parts[2].replace(',', '.'));
    var suffix = parts[3];
    if (isNaN(target)) return;

    ScrollTrigger.create({
      trigger: el,
      start: 'top 85%',
      once: true,
      onEnter: function() {
        var obj = { val: 0 };
        gsap.to(obj, {
          val: target,
          duration: 2,
          ease: 'power2.out',
          onUpdate: function() {
            el.textContent = prefix + Math.ceil(obj.val) + suffix;
          }
        });
      }
    });
  }

  // Cable les reveals d'un sous-arbre. Appele une fois sur le document, puis a
  // chaque injection de contenu.
  //
  // Un element deja cable ne doit pas l'etre deux fois : deux ScrollTrigger sur
  // la meme cible se marchent dessus. D'ou le marqueur data-reveal-bound.
  function revealWithin(root) {
    var scope = root || document;
    var handlers = {
      'fade-up': fadeUp,
      'line-draw': lineDraw,
      'stagger-children': staggerChildren,
      'counter': counter
    };

    Object.keys(handlers).forEach(function(mode) {
      scope.querySelectorAll('[data-reveal="' + mode + '"]:not([data-reveal-bound])').forEach(function(el) {
        el.setAttribute('data-reveal-bound', '');
        handlers[mode](el);
      });
    });

    // Le contenu injecte change la hauteur de la page : sans ce recalcul, les
    // declencheurs deja en place visent de mauvaises positions.
    if (root) ScrollTrigger.refresh();
  }

  revealWithin(document);

  // Crochet public. proart-related.liquid injecte des fiches produit apres le
  // chargement — elles portent data-reveal="fade-up" et le CSS les pose a
  // opacity: 0. Sans ce rappel, GSAP ne les voit jamais : la section « Complétez
  // votre setup » s'ouvrait sur une grille de cartes definitivement invisibles.
  // Tout code qui injecte du [data-reveal] doit appeler ceci.
  window.proartReveal = revealWithin;
});
